const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';
import SimpleLightbox from "simplelightbox";

require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_slider.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_woocommerce.js');

//Lightbox
let lightbox = new SimpleLightbox('.pdw-lightbox a', { /* options */});

//Drilldown menu
window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('ul.mobile-drilldown-menu li.menu-item-has-children > a').forEach(element => {
        //Create previous button
        let previous = document.createElement('span');
        element.nextElementSibling.prepend(previous);
        previous.classList.add("pdw-submenu-close");
        previous.innerHTML = element.innerHTML;
        previous.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.remove("open");
        });
        //Create open button
        let span = document.createElement('span');
        element.appendChild(span);
        span.classList.add("pdw-submenu-open");
        span.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.add("open");
            document.getElementById('pdw-mobile-menu').scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });
    });
});

//WooCommerce gallery
import Splide from '@splidejs/splide';

jQuery(document.body).on("wc-product-gallery-after-init", pdw_wc_gallery_thumbnails);

function pdw_wc_gallery_thumbnails() {
    let wc_gallery_thumbnails = document.querySelectorAll('.flex-control-thumbs');
    wc_gallery_thumbnails.forEach((item, index) => {
        let splideElement = document.createElement('div');
        splideElement.setAttribute("class", "splide");
        let splideTrack = document.createElement('div');
        splideTrack.setAttribute("class", "splide__track");

        item.querySelectorAll('li').forEach((child, index) => {
            child.classList.add('splide__slide');
        });
        item.classList.remove('flex-control-nav');
        item.classList.remove('flex-control-thumbs');
        item.classList.add('splide__list');
        item.parentNode.insertBefore(splideTrack, item);
        splideTrack.appendChild(item);
        splideTrack.parentNode.insertBefore(splideElement, splideTrack);
        splideElement.appendChild(splideTrack);
        let wc_gallery_thumbnail = new Splide(splideElement, {
            type: 'slide',
            perPage: 5,
            perMove: 1,
            pagination: false,
            gap: 10,
            arrowPath: 'M25.667,4.631a1.231,1.231,0,0,1,.549,1.649L19.11,20.5l7.109,14.218a1.231,1.231,0,1,1-2.2,1.1L16.633,21.052a1.231,1.231,0,0,1,0-1.1L24.018,5.18a1.231,1.231,0,0,1,1.649-.549Z'
        }).mount();
    });
}